import { environment } from '../../environments/environment';

export type CompanySearchApiResult = {
  primary_name: string;
  company_id: string;
  rcid: number;
  raw_emp_count: number;
  has_subsidiaries: boolean;
  ult_parent_name: string;
  ult_parent_rcid: number;
  primary_identifiers: {
    primary_name: string;
    primary_website: string;
    primary_ticker: string;
    primary_linkedin_url: string;
    country: string;
    state: string;
    city: string;
    rics_k10: number;
    rics_k400: number;
    rics_k400_name?: string;
    rics_k50: number;
  };
};

export const fetchCompanySearchResults = async (
  searchTerm: string,
  signal: AbortSignal
): Promise<CompanySearchApiResult[]> => {
  const response = await fetch(`${environment.COMPANY_MAPPER_URL}/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name: searchTerm, employee_cnt_min: 1 }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Search failed: ${response.status}`);
  }

  return response.json();
};
